import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import DiscreteTextButton from "@common/LifeAtButton/Variants/DiscreteTextButton";
import { FontSize } from "@themes/Fonts";
import Styles from "@themes/Styles";
import {
    DELETE_ACCOUNT_LINK,
    USER_DELETE_BUTTON_LABEL,
} from "@user/components/UserAccountModal/UserAccountModalConstants";

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: flex-start;
`;

const InfoBlock = styled.div`
    color: ${({ theme }) => theme.textColorSecondary};
    font-size: ${FontSize.normal};
`;

const Divider = styled.div`
    margin-top: 20px;
    padding: 10px 0;
    width: 100%;
    border-top: 1px solid lightgrey;
`;

const INFO_BLOCK_INFO_TEXT =
    "Permanently delete your LifeAt account and all of your data. Calendar or contact data from Google or Outlook will not be affected.";

function DeleteAccountBlock() {
    const history = useHistory();

    return (
        <Wrapper>
            <Divider></Divider>
            <InfoBlock>{INFO_BLOCK_INFO_TEXT}</InfoBlock>
            <DiscreteTextButton
                label={USER_DELETE_BUTTON_LABEL}
                onClick={() => history.push(DELETE_ACCOUNT_LINK)}
                colorOverride={Styles.lifeatSpecialRed}
            />
        </Wrapper>
    );
}

export default DeleteAccountBlock;
